import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import PostCard from "./PostCard";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowCircleUp,
  faCircleNotch,
} from "@fortawesome/free-solid-svg-icons";
import Button from "@restart/ui/esm/Button";
import { LinkContainer } from "react-router-bootstrap";

const Mines = ({ match }) => {
  const keyword = match.params.keyword;
  const [posts, setPosts] = useState([]);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async (keyword = "") => {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/posts/myposts?keyword=${keyword}`
      );
      setPosts(data);
      setLoading(false);
    };

    fetchPosts(keyword);

    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    });
  }, [keyword]);

  const scrollToTop = (e) => {
    e.preventDefault();

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      <Container className="pt-5 text-center" id="postContainer">
        {loading && (
          <FontAwesomeIcon icon={faCircleNotch} size="3x" className="fa-spin" />
        )}
        <LinkContainer to="/">
          <Button
            id="mdm"
            className="btn btn-secondary btn-outline-dark shadow-lg"
          >
            Back
          </Button>
        </LinkContainer>

        <Row xs={1} md={2} lg={3}>
          {posts
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            .map((post) => (
              <Col key={post._id}>
                <PostCard post={post} />
              </Col>
            ))}
        </Row>
      </Container>
      {visible && (
        <Button
          style={{ background: "transparent", border: "none" }}
          id="back-to-top"
        >
          <FontAwesomeIcon
            onClick={scrollToTop}
            icon={faArrowCircleUp}
            size="3x"
            style={{ color: "#343a40", display: visible ? "inline" : "none" }}
          />
        </Button>
      )}
    </>
  );
};

export default Mines;
